export class SortableItemState {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get item() {
        return this.parent;
    }
}
